import { Host, h } from "@stencil/core";
export class ListItemContent {
    constructor() {
        this.contentAlignment = undefined;
    }
    render() {
        return (h(Host, { key: '62c3187a790387131619a36041500bfa8411f1ef', class: {
                'bal-list__item__content': true,
                [`bal-list__item__content--${this.contentAlignment}`]: this.contentAlignment !== undefined,
            } }, h("slot", { key: '46b91cbcc099fadbc5d36cd38962cd269edfa061' })));
    }
    static get is() { return "bal-list-item-content"; }
    static get properties() {
        return {
            "contentAlignment": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "content-alignment",
                "reflect": false
            }
        };
    }
}
